'use strict';
exports.opening = require('./opening');
exports.closing = require('./closing');



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-html/lib/omission/index.js
// module id = 984
// module chunks = 0